import { useAuth } from "../../contexts/auth-context";
import useChatsUnreadSummaryQuery from "./useChatsUnreadSummaryQuery";

type UseOrderChatUnreadCountProps = {
  orderId: number | undefined;
  isOrderChatEnabled: boolean;
};

const useOrderChatUnreadCount = ({ orderId, isOrderChatEnabled }: UseOrderChatUnreadCountProps): number => {
  const { user } = useAuth();
  const customerId = user ? Number(user.id) || undefined : undefined;
  const { data } = useChatsUnreadSummaryQuery(customerId, { enabled: !!customerId && isOrderChatEnabled });

  if (!orderId) return 0;
  const item = data?.items.find((it) => it.orderId === orderId);
  return item?.unreadCount ?? 0;
};

export default useOrderChatUnreadCount;
